import { authenticatedDelete } from '../../../../../../api/request';

export default async function deleteSecondarySpecialty(idDoctorUser, idSpecialty, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error agregando su especialidad.');
    const url = `/doctor-profile-management/specialty/${idSpecialty}/doctor-user/${idDoctorUser}`;
    return await authenticatedDelete(url, onFail);
}
